"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10CommonComponents = require("r10-common-components");
var _services = require("../../services");
var _PaymentOption = _interopRequireDefault(require("../shared/PaymentOption"));
var _useInsuranceActions = _interopRequireDefault(require("../../hooks/upsell/useInsuranceActions"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const UpsellInsuranceCard = _ref => {
  let {
    index,
    product,
    onAddToCart,
    onRemoveFromCart,
    isDisabled,
    isSelected
  } = _ref;
  const {
    name,
    paymentOptions,
    topFeaturesList
  } = product;
  const {
    onViewMore
  } = (0, _useInsuranceActions.default)();
  const nonZeroPaymentOptions = paymentOptions.map((option, index) => ({
    label: /*#__PURE__*/_react.default.createElement(_PaymentOption.default, {
      key: index,
      price: option.label
    }),
    price: option.price
  })).filter(option => {
    return option.price.value !== 0;
  });
  return /*#__PURE__*/_react.default.createElement(_r10CommonComponents.GenericUpSellingCard, {
    maxFeatures: 3,
    id: `insurance-card-${index}`,
    topFeaturesList: topFeaturesList,
    viewMoreText: _services.Services.locale.localeString('RelationshipOffer.ViewMore'),
    onViewMore: () => {
      onViewMore(product);
    },
    title: name,
    paymentData: nonZeroPaymentOptions,
    isSelected: isSelected,
    addToCartCTA: {
      state: isDisabled ? 'disabled' : '',
      text: _services.Services.locale.localeString('RelationshipOffer.AddToCart'),
      action: () => {
        onAddToCart(product);
      }
    },
    removeFromCartCTA: {
      text: _services.Services.locale.localeString('RelationshipOffer.RemoveFromCart'),
      action: () => {
        onRemoveFromCart(product);
      }
    }
  });
};
var _default = UpsellInsuranceCard;
exports.default = _default;